// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

/**
 * ⭐ UNIVERSAL reCAPTCHA INITIALIZER
 * Works for:
 * - reCAPTCHA v2
 * - reCAPTCHA Enterprise fallback
 * - Firebase SDK v12+
 * - Invisible mode
 */
export const generateRecaptcha = () => {
  if (!window.recaptchaVerifier) {
    console.log("⚡ Initializing RecaptchaVerifier...");

    window.recaptchaVerifier = new RecaptchaVerifier(
      auth, // <-- Works for both Enterprise + v2
      "recaptcha-container", // Must exist in DOM
      {
        size: "invisible",

        callback: () => {
          console.log("✔ reCAPTCHA solved");
        },

        "expired-callback": () => {
          console.log("❗ reCAPTCHA expired");
          window.recaptchaVerifier.clear();
          window.recaptchaVerifier = null;
        }
      }
    );
  }

  return window.recaptchaVerifier;
};
